/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React from "react";
import Breadcrumbs from "./../breadcrumbs/BreadcrumbsRedux";
import TitleBarMenu from "./TitleBarMenu";
import Branding from "./branding/Branding";
import Vr from "./../vr/Vr";
import "./titleBar.less";
import BrandLogo from "./BrandLogo";

const TitleBar = (props) => {
  let breadcrumbArray = window.location.pathname.endsWith("/treeviewnew")?props.breadCrumbs.slice(0,2):props.breadCrumbs;
  breadcrumbArray = breadcrumbArray.filter((v,i,a)=>a.findIndex(v2=>['name'].every(k=>v2[k] ===v[k]))===i);

  breadcrumbArray = breadcrumbArray.filter((bredCrumb) => bredCrumb.name !== undefined)
  return (
    <header className="titlebarheader">
      <BrandLogo />
      <Branding saas={props.saas} />
      <Vr />
      <div
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          position: "relative",
        }}
      >
        <button
          tabIndex={0}
          className="skip-content-link" style={{marginTop:breadcrumbArray?.length===1?'2px':'8px'}}
          onClick={()=>{document.getElementById('first-content-element')?.focus()}}
        >
          Skip to main content
        </button>
        <Breadcrumbs className="titlebarheader__breadcrumb" />
      </div>
      <TitleBarMenu {...props} />
    </header>
  );
};

export default TitleBar;
